import {batchHandleUrl} from '../../../utils/url-handle.js'

const router = {
  // 获取按钮路由
  routeLayout: {
    url: '/apaas/route/routeLayout',
    type: 'post'
  },
  // 获取不控权按钮路由
  noAuthRouteLayout: {
    url: '/apaas/route/noAuthRouteLayout',
    type: 'post'
  }
}
export default batchHandleUrl(router)
